/**
 * Categorias opcionais por tipo de esporte (código estável armazenado em `Game.sportCategory`).
 */
export const SPORT_CATEGORY_OPTIONS: Record<
  string,
  readonly { value: string; label: string }[]
> = {
  BEACH_TENNIS: [
    { value: "BT_MIXED", label: "Misto" },
    { value: "BT_M_DUP", label: "Dupla masculina" },
    { value: "BT_F_DUP", label: "Dupla feminina" },
    { value: "BT_BEGIN", label: "Iniciante" },
    { value: "BT_INT", label: "Intermediário" },
    { value: "BT_ADV", label: "Avançado" },
    { value: "BT_TRAIN", label: "Treino" },
  ],
  CARIMBA: [
    { value: "CAR_KIDS", label: "Infantil" },
    { value: "CAR_JUV", label: "Juvenil" },
    { value: "CAR_ADULT", label: "Adulto" },
    { value: "CAR_MIX", label: "Misto" },
    { value: "CAR_REC", label: "Recreativo" },
    { value: "CAR_COMP", label: "Competitivo" },
  ],
  CORRIDA: [
    { value: "RUN_3K", label: "3 km" },
    { value: "RUN_5K", label: "5 km" },
    { value: "RUN_6K", label: "6 km" },
    { value: "RUN_10K", label: "10 km" },
    { value: "RUN_15K", label: "15 km" },
    { value: "RUN_HALF", label: "21 km (meia)" },
    { value: "RUN_FULL", label: "42 km (maratona)" },
    { value: "RUN_ULTRA", label: "Ultra" },
    { value: "RUN_TRAIL", label: "Trail" },
    { value: "RUN_ROAD", label: "Rua / asfalto" },
    { value: "RUN_TRACK", label: "Pista" },
    { value: "RUN_KIDS", label: "Kids / fun run" },
  ],
  FUTEBOL: [
    { value: "FUT_SOCIETY", label: "Society" },
    { value: "FUT_FUTSAL", label: "Futsal" },
    { value: "FUT_7", label: "Fut 7" },
    { value: "FUT_11", label: "Campo 11" },
    { value: "FUT_BEACH", label: "Fut areia" },
    { value: "FUT_VARZEA", label: "Várzea / amador" },
  ],
  VOLEI: [
    { value: "VOL_INDOOR", label: "Quadra (indoor)" },
    { value: "VOL_SAND", label: "Areia 4x4 (4 por time)" },
    { value: "VOL_MIX", label: "Misto" },
    { value: "VOL_W", label: "Feminino" },
    { value: "VOL_M", label: "Masculino" },
    { value: "VOL_BEGIN", label: "Iniciante" },
    { value: "VOL_INT", label: "Intermediário" },
    { value: "VOL_ADV", label: "Avançado" },
  ],
  OUTRO: [
    { value: "OTH_FRIENDLY", label: "Amistoso" },
    { value: "OTH_TRAIN", label: "Treino" },
    { value: "OTH_EVENT", label: "Evento / festival" },
    { value: "OTH_OTHER", label: "Outro" },
  ],
};

export function getSportCategoriesForSport(
  sport: string | undefined,
): { value: string; label: string }[] {
  if (!sport || !SPORT_CATEGORY_OPTIONS[sport]) return [];
  return [...SPORT_CATEGORY_OPTIONS[sport]];
}

/** Rótulo para exibição no card / detalhes; `undefined` se sem categoria ou código desconhecido. */
export function getSportCategoryLabel(
  sport: string | undefined,
  category: string | null | undefined,
): string | undefined {
  if (!category?.trim()) return undefined;
  const list = SPORT_CATEGORY_OPTIONS[sport ?? ""];
  if (!list) return undefined;
  return list.find((c) => c.value === category)?.label;
}
